import { AxiosResponse } from 'axios';
import { v4 as uuidv4 } from 'uuid';

import apiRequest from '@/utils/apiRequest';

export async function postAnalyticsProperties(deviceType: string): Promise<AxiosResponse> {
	const eventTimestamp = new Date();
	return apiRequest({
		endpoint: 'v1/events',
		method: 'POST',
		isHermes: true,
		body: {
			batch_id: uuidv4(),
			batch_timestamp: eventTimestamp,
			events: [
				{
					event_id: uuidv4(),
					event_timestamp: eventTimestamp,
					user_properties: { web_device_type: deviceType },
				},
			],
			partners_handled: [
				'appsflyer',
				'amplitude',
				'facebook_control',
				'facebook_placebo',
				'facebook_testing',
			],
		},
	});
}
